import { COLLECT_DROP_EVENT_DATA } from 'root/src/shared/descriptions/endpoints/endpointIds'

import cronJobPayloadSchema from 'root/src/shared/descriptions/endpoints/schemas/requestSchemas/cronJobPayloadSchema'

export default {
	[COLLECT_DROP_EVENT_DATA]: {
		payloadSchema: cronJobPayloadSchema,
		isCron: true,
	},
}
